import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/warning-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-34c673de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-wrapper" }
const _hoisted_2 = {
  key: 0,
  ref: "content",
  class: "content"
}
const _hoisted_3 = { class: "pay-history-list" }
const _hoisted_4 = {
  key: 1,
  class: "no-content"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "warning-icon",
  src: _imports_0,
  alt: "경고 아이콘"
}, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "결제 내역이 없습니다.", -1 /* HOISTED */))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "book-confirmation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createVNode($setup["NavigationBar"], { title: "결제내역" }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "filter",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.shouldShowFilters = true))
        }, [
          _createElementVNode("span", null, _toDisplayString($setup.currentFilterStr), 1 /* TEXT */),
          _createVNode($setup["InlineSvg"], {
            src: require('@/assets/icons/chevron-down.svg'),
            alt: ""
          }, null, 8 /* PROPS */, ["src"])
        ])
      ]),
      ($setup.filteredPaymentInfos.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredPaymentInfos, (paymentInfo) => {
                return (_openBlock(), _createBlock($setup["PaymentHistoryRow"], {
                  key: paymentInfo.payUid,
                  paymentInfo: paymentInfo,
                  onClick: ($event: any) => ($setup.onSelectPaymentInfo(paymentInfo))
                }, null, 8 /* PROPS */, ["paymentInfo", "onClick"]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 512 /* NEED_PATCH */))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [..._hoisted_7])),
      ($setup.shouldShowFilters)
        ? (_openBlock(), _createBlock($setup["FilterModal"], {
            key: 2,
            filters: $setup.filters,
            initialAppliedFilters: $setup.currentFilter,
            onOnClickClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.shouldShowFilters = false)),
            onOnClickApply: $setup.onClickFilterApply
          }, null, 8 /* PROPS */, ["filters", "initialAppliedFilters"]))
        : _createCommentVNode("v-if", true),
      ($setup.showDetail && $setup.paymentDetailInfo)
        ? (_openBlock(), _createBlock($setup["PaymentHistoryDetail"], {
            key: 3,
            paymentDetailInfo: $setup.paymentDetailInfo,
            onOnClickClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.showDetail = false)),
            onOnClickBookDetailId: $setup.onClickBookDetailId
          }, null, 8 /* PROPS */, ["paymentDetailInfo"]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.showBookHistoryDetail,
        onBackHandler: () => $setup.toggleShowBookHistoryDetail(false)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            ($setup.selectedBookInfo)
              ? (_openBlock(), _createBlock($setup["BookHistoryDetail"], {
                  key: 0,
                  bookInfo: $setup.selectedBookInfo,
                  turnId: $setup.selectedBookInfo.turnId,
                  oneTimeFare: $setup.selectedBookInfo.bookAmount,
                  onOnClickClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleShowBookHistoryDetail(false))),
                  onOnCompleteBookCancel: $setup.onCompleteBookCancel
                }, null, 8 /* PROPS */, ["bookInfo", "turnId", "oneTimeFare"]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]),
    _: 1 /* STABLE */
  }))
}